module.exports = __webpack_public_path__ + "d88df17e56dd70c1e25ab8494f5c7f49.png";